/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, InputAdornment, List, ListItemIcon, ListItemText, Snackbar, SnackbarContent, TextField } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { withStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import {
    serialNumberClassificationBulletinEndpoint, serialNumberClassificationDownloadsEndpoint, serialNumberClassificationInstrumentConstantsEndpoint,
    serialNumberClassificationLabourTimeGuideEndpoint, serialNumberClassificationManualEndpoint
} from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';

interface Props {
    handleSerialNumberSearch: Function,
    classes?: any,
    productModels: any,
    families: any,
    productNames: any,
    isLoading: any,
    LoadServiceManual: Function
    selectedProductModel: any
    selectedProductName: any
    selectedFamily: any
    serialNumber: any
    UpdateSerialNumber: Function
    StopLoading: Function
    isBulletin: boolean,
    isDownloads: boolean,
    isLaborTimeGuide: boolean,
    isInstrumentConstants: boolean,
    ClearAll: Function
}
const styles = () => ({
    input: {
        backgroundColor: '#fff',
        height: 48,
        width: 312
    },
    root: {
        justifyContent: 'center'
    }
})

class SerialNumberSearch extends React.Component<Props> {
    state = {
        open: false,
        productlist: [],
        checked: undefined,
        setChecked: undefined,
        selectedindex: 0,
        validationError: ''
    };
    handleChange = (event: any) => {
        this.props.UpdateSerialNumber(event.target.value);
    };
    handlekeyPress = (event: any) => {
        this.setState({ selectedindex: 0 });
        if (event.key === 'Enter') {
            try {

                this.props.LoadServiceManual(event.target.value);
                this.props.ClearAll();
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = this.props.isBulletin ? serialNumberClassificationBulletinEndpoint : this.props.isLaborTimeGuide ?
                    serialNumberClassificationLabourTimeGuideEndpoint : this.props.isDownloads ? serialNumberClassificationDownloadsEndpoint : this.props.isInstrumentConstants ?
                        serialNumberClassificationInstrumentConstantsEndpoint : serialNumberClassificationManualEndpoint;
                fetch(endpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify({
                        'serialNumber': event.target.value
                    }),
                    method: 'POST'
                })
                    .then(async (response: any) => {
                        const data = await response.json();

                        switch (response.status) {
                            case 200: {
                                if (data.partDetails.length > 1) {
                                    console.log(data.partDetails);
                                    this.setState({ productlist: data.partDetails });
                                    this.setState({ open: true });
                                }
                                else if (data.partDetails.length === 1 && data.partDetails.classificationDetails !== null) {
                                    console.log(data.partDetails[0].servicebulletins);
                                    if (data.partDetails[0].isValid) {
                                        if (this.props.isBulletin) {
                                            this.props.handleSerialNumberSearch([data.partDetails[0].classificationDetails.twoDproductFamilyid],
                                                [data.partDetails[0].classificationDetails.twoDproductNameid], [data.partDetails[0].classificationDetails.twodModelid],
                                                data.partDetails[0].servicebulletins);
                                        }
                                        else if (this.props.isLaborTimeGuide) {
                                            this.props.handleSerialNumberSearch([data.partDetails[0].classificationDetails.twoDproductFamilyid],
                                                [data.partDetails[0].classificationDetails.twoDproductNameid], [data.partDetails[0].classificationDetails.twodModelid],
                                                data.partDetails[0].ltgDetails);
                                        }
                                        else if (this.props.isDownloads) {
                                            this.props.handleSerialNumberSearch([data.partDetails[0].classificationDetails.twoDproductFamilyid],
                                                [data.partDetails[0].classificationDetails.twoDproductNameid], [data.partDetails[0].classificationDetails.twodModelid],
                                                data.partDetails[0].downloads);
                                        }
                                        else if (this.props.isInstrumentConstants) {
                                            this.props.handleSerialNumberSearch([data.partDetails[0].classificationDetails.twoDproductFamilyid],
                                                [data.partDetails[0].classificationDetails.twoDproductNameid], [data.partDetails[0].classificationDetails.twodModelid],
                                                data.partDetails[0].constants, [data.partDetails[0].classificationDetails.twodModelname]);
                                        }
                                        else {
                                            this.props.handleSerialNumberSearch([data.partDetails[0].classificationDetails.twoDproductFamilyid],
                                                [data.partDetails[0].classificationDetails.twoDproductNameid], [data.partDetails[0].classificationDetails.twodModelid],
                                                data.partDetails[0].servicemanuals);
                                        }
                                    }
                                    else {
                                        this.setState({ validationError: 'Product Part Number Configuration not found' });
                                        this.props.StopLoading();
                                    }
                                }
                                else {
                                    this.props.StopLoading();
                                }


                                break;
                            }
                            case 400:
                                this.setState({ validationError: 'Error' });
                                this.props.StopLoading();
                                break;
                            case 404:
                                this.setState({ validationError: 'Product not found' });
                                this.props.StopLoading();
                                break;
                            case 500:
                                this.setState({ validationError: 'SerialNumber not found' });
                                this.props.StopLoading();
                                break;
                            default:
                                this.setState({ validationError: 'Product not found' });
                                this.props.StopLoading();
                        }
                    });
            }
            catch (e) { console.log(e); }
        }
    };

    handleClose = (value: any) => {
        this.props.StopLoading();
        this.setState({ selectedValue: value, open: false });
    };
    handleSnackBarClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ validationError: '' });
    };
    handleCheckboxChange = (index: any) => {
        this.setState({ selectedindex: index });

    };
    handleOk = async () => {
        const no = this.state.selectedindex;
        let selectedvalue: any;
        selectedvalue = this.state.productlist[no];
        if (selectedvalue.isValid) {
            if (selectedvalue !== undefined && selectedvalue.classificationDetails !== undefined) {
                if (this.props.isBulletin) {
                    this.props.handleSerialNumberSearch([selectedvalue.classificationDetails.twoDproductFamilyid], [selectedvalue.classificationDetails.twoDproductNameid],
                        [selectedvalue.classificationDetails.twodModelid], selectedvalue.servicebulletins);
                }
                else if (this.props.isLaborTimeGuide) {
                    this.props.handleSerialNumberSearch([selectedvalue.classificationDetails.twoDproductFamilyid], [selectedvalue.classificationDetails.twoDproductNameid],
                        [selectedvalue.classificationDetails.twodModelid], selectedvalue.ltgDetails);
                }
                else if (this.props.isDownloads) {
                    this.props.handleSerialNumberSearch([selectedvalue.classificationDetails.twoDproductFamilyid], [selectedvalue.classificationDetails.twoDproductNameid],
                        [selectedvalue.classificationDetails.twodModelid], selectedvalue.downloads);
                }
                else if (this.props.isInstrumentConstants) {
                    this.props.handleSerialNumberSearch([selectedvalue.classificationDetails.twoDproductFamilyid], [selectedvalue.classificationDetails.twoDproductNameid],
                        [selectedvalue.classificationDetails.twodModelid], selectedvalue.constants, [selectedvalue.classificationDetails.twodModelname]);
                }
                else {
                    this.props.handleSerialNumberSearch([selectedvalue.classificationDetails.twoDproductFamilyid], [selectedvalue.classificationDetails.twoDproductNameid],
                        [selectedvalue.classificationDetails.twodModelid], selectedvalue.servicemanuals);
                }
            }
        }
        else {
            this.setState({ validationError: 'Product Part Number Configuration not found' });
            this.props.StopLoading();
        }
        this.setState({ open: false });
    };

    render() {
        const { classes } = this.props;
        const { productlist } = this.state;
        const { serialNumber } = this.props;
        return (
            <div >
                <TextField
                    name="serialNumber"
                    onChange={this.handleChange}
                    onKeyPress={this.handlekeyPress}
                    value={serialNumber}
                    variant="outlined"
                    InputProps={{
                        className: classes.input, startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{ shrink: false }}
                    label={serialNumber === '' ? 'Serial Number' : ''}
                    className="serialNumberinput"
                />

                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="simple-dialog-title" scroll="paper">
                    <div>
                        <DialogTitle id="simple-dialog-title">Duplicate Serial Number</DialogTitle>
                        <div>
                            &nbsp; &nbsp; &nbsp; &nbsp; Select product part number
                            <List>
                                {productlist.map((value: any, index: any) => {
                                    const labelId = `checkbox-list-label-${value}`;

                                    return (
                                        <ListItemButton className={classes.checkListItem} key={value} role={undefined} dense onClick={() => this.handleCheckboxChange(index)}>

                                            <ListItemIcon className={classes.checkListItemIcon}>
                                                <Checkbox
                                                    checked={this.state.selectedindex === index}
                                                    tabIndex={-1} className={classes.checkBox}
                                                />
                                            </ListItemIcon>
                                            <ListItemText id={index} primary={` ${value.partNumber}`} />
                                        </ListItemButton>
                                    );
                                })}
                            </List>
                        </div>
                        <div className={classes.buttons}>
                            <Button className={classes.save} onClick={() => { this.handleOk(); }} variant="outlined" style={
                                {
                                    backgroundColor: '#005f9e',
                                    justifyContent: 'center',
                                    marginLeft: 100,
                                    marginBottom: 10,
                                    color: 'white',
                                    borderRadius: 0
                                } as React.CSSProperties}>OK</Button>
                        </div>
                    </div>
                </Dialog>
                <Snackbar
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom'
                    }}
                    open={this.state.validationError !== ''}
                    autoHideDuration={5000}
                    onClose={this.handleSnackBarClose}
                >
                    <SnackbarContent
                        className="search-input-snackbar"
                        message={this.state.validationError}
                    />
                </Snackbar>
            </div>


        );
    }
}

export default withStyles(styles)(SerialNumberSearch);
